(function () {
  const instances = new Map();

  function init(section) {
    const sectionId = section.dataset.sectionId;
    if (instances.has(sectionId)) return; // Evitar doble inicialización

    const track = section.querySelector('.lb-carousel__track');
    const nextBtn = section.querySelector('.lb-next');
    const prevBtn = section.querySelector('.lb-prev');

    if (!track) return;

    /* ===== DESKTOP SLIDER ===== */
    let animating = false;

    function slideNext() {
      if (animating) return;
      animating = true;

      const w = track.children[0].offsetWidth + 16;
      track.style.transition = 'transform 0.35s ease';
      track.style.transform = `translateX(-${w}px)`;

      track.addEventListener('transitionend', function h() {
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        track.appendChild(track.firstElementChild);
        animating = false;
        track.removeEventListener('transitionend', h);
      });
    }

    function slidePrev() {
      if (animating) return;
      animating = true;

      const w = track.children[0].offsetWidth + 16;
      track.style.transition = 'none';
      track.insertBefore(track.lastElementChild, track.firstElementChild);
      track.style.transform = `translateX(-${w}px)`;

      requestAnimationFrame(() => {
        track.style.transition = 'transform 0.35s ease';
        track.style.transform = 'translateX(0)';
      });

      track.addEventListener('transitionend', function h() {
        animating = false;
        track.removeEventListener('transitionend', h);
      });
    }

    if (nextBtn && prevBtn) {
      nextBtn.addEventListener('click', slideNext);
      prevBtn.addEventListener('click', slidePrev);
    }

    /* ===== MOBILE TAP FLIP ===== */
    if (window.matchMedia('(max-width: 768px)').matches) {
      let moved = false;
      const viewport = section.querySelector('.lb-carousel__viewport');

      if (viewport) {
        viewport.addEventListener('touchstart', () => moved = false);
        viewport.addEventListener('touchmove', () => moved = true);
      }

      section.querySelectorAll('.lb-card').forEach(card => {
        card.addEventListener('click', (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          const open = section.querySelector('.lb-card.is-flipped');
          if (open && open !== card) open.classList.remove('is-flipped');
          card.classList.toggle('is-flipped');
        });
      });
    }

    instances.set(sectionId, true);
  }

  document.addEventListener('section:lb-carousel-ingredients:load', (e) => {
    init(e.detail);
  });
})();
